import React from 'react';
import {Button, ButtonGroup, Container} from "@mui/material";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";

const buttonSx = {
    padding: 0,
    minWidth: '25px !important',
    height: '25px',
    width: '25px'
}

function ArrayShifter({shiftTo, index, length, horizontal}) {
    const handleChange = (value) => {
        shiftTo(index, Math.max(0, Math.min(index + value, length)));
    };

    return (
        <Container disableGutters sx={{pt: 1 || 'initial', width: 'initial', margin: 0}}>
            <ButtonGroup>
                <Button sx={buttonSx}
                        onClick={() => handleChange(-1)}
                        color={"secondary"}
                >
                    {horizontal ? <KeyboardArrowUp fontSize="small" sx={{padding: 0}}/> :
                        <KeyboardArrowLeftIcon fontSize="small" sx={{padding: 0}}/>}
                </Button>
                <Button sx={buttonSx}
                        onClick={() => handleChange(1)}
                        color={"secondary"}
                >
                    {horizontal ? <KeyboardArrowDown fontSize="small" sx={{padding: 0}}/> :
                        <KeyboardArrowRightIcon fontSize="small" sx={{padding: 0}}/>}


                </Button>
            </ButtonGroup>
        </Container>
    );
}

export default ArrayShifter;